import React from "react";
import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";

import IgErrorBoundary from "../../components/Utils/IgErrorBoundary";
import { NotSubscribedRoute } from "../../domains/NotSubscribed";
import { LoggedInProvider } from "../../providers/LoggedInProvider";

const routes: RouteObject[] = [
  {
    errorElement: (
      <LoggedInProvider>
        <IgErrorBoundary />
      </LoggedInProvider>
    ),
    element: <LoggedInProvider />,
    children: [
      {
        element: <NotSubscribedRoute />,
        path: "*",
      },
    ],
  },
];
const router = createBrowserRouter(routes);

export const NotSubscribedRoutes = () => {
  return <RouterProvider router={router} />;
};
